<template>
  <b-row>
    <b-col cols="12">
      <b-row
        align-h="between"
        class="mb-50"
      >
        <b-col cols="11">
          <div style="display:flex;justify-content: center;">
            <h4
              style="display: flex;margin-left: 10rem;"
            >
              Acompanhamento de propostas finalizadas
              <div style="padding-left: 0.4rem">
                <i
                  v-b-tooltip.hover
                  :title="'Nesse gráfico é possível acompanhar a finalização das propostas com status (Aprovadas), (Rejeitadas) e (Expiradas) em quantidades e valores. Como padrão ao acessar o dashboard, o filtro de data virá com os últimos 12 meses mais a competência atual filtrado. Para o índice de aprovadas, é validado as colunas Aprovadas e Finalizadas'"
                  style="font-size: 0.85rem;"
                  class="question-icon"
                >
                  <font-awesome-icon
                    :icon="faQuestionCircle"
                  />
                </i>
              </div>
            </h4>
          </div>
        </b-col>
        <b-col cols="auto">
          <div>
            <b-btn
              v-b-tooltip.hover
              title="Download planilha"
              variant="none"
              @click="gerarDados"
            >
              <font-awesome-icon
                :icon="faDownload"
              />
            </b-btn>
          </div>
          <a
            id="download"
            download
            href=""
            hidden
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col
          style="display: flex;align-items: center;justify-content: space-between;"
          cols="12"
        >
          <div style="display: flex;margin-left: 2rem;">
            <div>
              <feather-icon
                size="55"
                icon="CheckCircleIcon"
                class="mr-50"
                style="color:#00C16C"
              />
              <div style="float:right">
                <div>
                  Aprovadas: <b>{{ dados.quantidadeTotalAprovadas }}</b>
                </div>
                <div> Valor: <b>{{ dados.valoresAprovada.reduce((partialSum, a) => partialSum + a, 0)| converteValor }}</b></div>
              </div>
            </div>

            <div style="margin-left: 20px;">
              <feather-icon
                size="55"
                icon="XOctagonIcon"
                class="mr-50"
                style="color: #EF7564"
              />
              <div style="float:right">
                <div>
                  Rejeitadas: <b>{{ dados.quantidadeTotalRejeitadas }}</b>
                </div>
                <div> Valor: <b>{{ dados.valoresRejeitada.reduce((partialSum, a) => partialSum + a, 0 ) | converteValor }}</b></div>
              </div>
            </div>

            <div style="margin-left: 20px;">
              <feather-icon
                size="55"
                icon="ClockIcon"
                class="mr-50"
                style="color: #FFAF3F;"
              />
              <div style="float:right">
                <div>
                  Expiradas: <b>{{ dados.quantidadeTotalExpiradas }}</b>
                </div>
                <div> Valor: <b>{{ dados.valoresExpirada.reduce((partialSum, a) => partialSum + a, 0) | converteValor }}</b></div>
              </div>
            </div>
          </div>

          <div style="display: flex;">
            <b-col>
              <b-form-group
                label="Competência inicial"
                style="margin-left: 10px;"
              >
                <vue-monthly-picker
                  v-model="valueInner.dataInicio"
                  :input-class="'input-sm form-control w-100'"
                  :date-format="'MM/YYYY'"
                  :month-labels="['Jan', 'Fev', 'Mar','Abr','Maio','Jun','Jul','Ago','Set','Out','Nov','Dez']"
                  :alignment="'left'"
                />
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Competência final">
                <vue-monthly-picker
                  v-model="valueInner.dataFim"
                  :input-class="'input-sm form-control w-100' "
                  :date-format="'MM/YYYY'"
                  :month-labels="['Jan', 'Fev', 'Mar','Abr','Maio','Jun','Jul','Ago','Set','Out','Nov','Dez']"
                  :alignment="'left'"
                />
              </b-form-group>

            </b-col>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
        >
          <line-chart-comercial
            v-if="carregado"
            :id="$index"
            :dados="dados"
            :height="550"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>
    <style lang="scss">
    </style>
<script>
import VueMonthlyPicker from 'vue-monthly-picker'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle, faDownload,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comercial/dashboard-comercial/shared/services/api'

export default {
  name: 'DetalhamentoFinalizadas',
  components: {
    VueMonthlyPicker,
    FontAwesomeIcon,
    LineChartComercial: () => import('@/shared/components/lineChart-comercial/LineChartComercial.vue'),
  },
  data() {
    return {
      faDownload,
      dados: [],
      valueInner: {
        dataInicio: null,
        dataFim: null,
      },
      faQuestionCircle,
      now: new Date(),
      carregado: false,
      dadosExportacao: {
        campos: ['Data aprovação', 'Data rejeição', 'Data expiração', 'Tipo', 'Número proposta', 'Data envio', 'Valor original', 'Acréscimos', 'Descontos', 'Valor total', 'Responsável', 'Pessoa', 'Contratante', 'Data Início na Auditar', 'Serviços', 'Integração Omie'],
        datas: [],
      },
    }
  },
  watch: {
    'valueInner.dataFim': function (value, oldValue) {
      if (value !== oldValue) {
        const data = value.toDate()
        this.valueInner.dataFim = (moment(new Date(data)).format('YYYY/MM'))

        const dataFim = this.valueInner.dataFim.split('/')
        const dataInicio = this.valueInner.dataInicio.split('/')
        if (Number(dataFim[0]) < Number(dataInicio[0])) {
          this.$erro('Não há dados, verifique o filtro informado!')
          return
        }

        this.carregaDados()
      }
    },
    'valueInner.dataInicio': function (value, oldValue) {
      if (value !== oldValue) {
        const data = value.toDate()
        this.valueInner.dataInicio = (moment(new Date(data)).format('YYYY/MM'))

        const dataFim = this.valueInner.dataFim.split('/')
        const dataInicio = this.valueInner.dataInicio.split('/')

        if (Number(dataFim[0]) < Number(dataInicio[0])) {
          this.$erro('Não há dados, verifique o filtro informado!')
          return
        }

        this.carregaDados()
      }
    },
  },
  created() {
    this.valueInner.dataFim = (moment(new Date(this.now)).format('YYYY/MM'))
    this.valueInner.dataInicio = (moment(new Date(this.now.getFullYear() - 1, this.now.getMonth())).format('YYYY/MM'))
    this.dadosExportacao.datas.push(this.valueInner.dataFim)
    this.carregaDados()
  },
  methods: {
    carregaDados() {
      this.carregado = false
      api.getDetalhamentoFinalizadas(`${this.valueInner.dataInicio}-${this.valueInner.dataFim}`)
        .then(payload => {
          this.dados = payload.data
          if (this.dados.competencias.length === 1) {
            this.dados.competencias.unshift(' ')

            this.dados.quantidadeAprovadas.unshift(0)
            this.dados.quantidadeExpiradas.unshift(0)
            this.dados.quantidadeRejeitadas.unshift(0)

            this.dados.valoresAprovada.unshift(0)
            this.dados.valoresExpirada.unshift(0)
            this.dados.valoresRejeitada.unshift(0)
          }
        })
        .finally(() => {
          this.carregado = true
        })
    },
    gerarDados() {
      this.dadosExportacao.datas = [`${this.valueInner.dataInicio}-${this.valueInner.dataFim}`]
      this.$isLoading(true)
      api.gerarPlanilhaPropostasFinalizadas(this.dadosExportacao)
        .then(payload => {
          if (payload.data.url !== '') {
            document.getElementById('download').href = payload.data.url
            document.getElementById('download').click()
          }
          this.deletarUpload(payload.data.fileName)
        })
        .catch(err => {
          this.$erroResponse(err)
          throw err
        })
        .finally(() => {
          this.$isLoading(false)
        })
    },
    deletarUpload(data) {
      setTimeout(() => {
        api.deleteUpload(data)
          .then(resolve => {
            this.$isLoading(false)
            this.$sucesso('Planilha gerada com sucesso')
            resolve()
          })
      }, 3000)
    },
  },
}
</script>
